var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 42.1429,
    height: 39.2857,
    rx: 10,
    fill: "#F8C747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.219 10.4496L30.9795 13.2101L31.7565 12.4331C33.2098 10.9798 30.4492 8.21832 28.996 9.67263L28.219 10.4496ZM31.0366 18.8927V27.5465C31.0366 29.3053 29.6013 30.7405 27.8426 30.7405H13.8832C12.1244 30.7405 10.6892 29.3052 10.6892 27.5465V13.5871C10.6892 11.8283 12.1245 10.3931 13.8832 10.3931H22.537V12.1804H13.8832C13.111 12.1804 12.4763 12.815 12.4763 13.5873V27.5467C12.4763 28.3189 13.111 28.9536 13.8832 28.9536H27.8426C28.6148 28.9536 29.2495 28.3189 29.2495 27.5467V18.8929L31.0366 18.8927ZM30.1648 14.0261L21.2977 22.8932L18.2146 23.2157L18.5371 20.1327L27.4043 11.2645L30.1648 14.0261Z",
    fill: "#F8C747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.97c88d76232e99934ef87f66ae2a22ee.svg";
export { ForwardRef as ReactComponent };